import React from 'react';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { testId } from 'ui-components/services/testid-service';
import style from './grid-loading.module.css';

const GridLoading = () => (
  <div className={style['grid-loading']} {...testId('grid-loading')}>
    <LoadingIndicator />
  </div>
);

export default GridLoading;
